// Power-up content, verbatim from v1 js/constants.js:675-700 (POWER_UP_TYPES).

export type PowerUpId = 'star' | 'multiplier' | 'magnet';

export interface PowerUpDef {
  id: PowerUpId;
  duration: number;
  color: number;
  emissiveColor: number;
  label: string;
  hudColor: string;
}

export const POWER_UP_TYPES: Record<PowerUpId, PowerUpDef> = {
  star: {
    id: 'star',
    duration: 6,
    color: 0xffd700,
    emissiveColor: 0xff8800,
    label: 'INVINCIBLE',
    hudColor: '#FFD700',
  },
  multiplier: {
    id: 'multiplier',
    duration: 10,
    color: 0xff4400,
    emissiveColor: 0xff2200,
    label: '2X SCORE',
    hudColor: '#FF6600',
  },
  magnet: {
    id: 'magnet',
    duration: 10,
    color: 0x00aaff,
    emissiveColor: 0x0055cc,
    label: 'MEGA MAGNET',
    hudColor: '#00AAFF',
  },
};

export const POWER_UP_IDS: readonly PowerUpId[] = ['star', 'multiplier', 'magnet'];
// v1 game3d.js:1108 — mega magnet multiplies the attraction radius
export const MAGNET_RADIUS_MULTIPLIER = 4.0;
